import React from "react";
import "./Input.css";

function Input({
  label,
  onUpdateValue,
  value,
  isInvalid,
  placeholder,
  autocorrect,
  autocomplete,
  maxLength,
  type,
  multiline,
}) {
  return (
    <div className="inputContainer">
      <p className={!isInvalid ? "label" : "labelInvalid"}>{label}</p>
      <input
        className={`input ${isInvalid && "inputInvalid"}`}
        autoCapitalize="none"
        maxLength={maxLength}
        onChange={onUpdateValue}
        value={value}
        type={type}
        placeholder={placeholder}
        autoComplete={autocomplete}
        rows={multiline ? 5 : 1}
      />
    </div>
  );
}

export default Input;
